<template>
  <div class="sidebar">
    <SidebarSwitcher @input="selectType" :items="menu" :value="filters.type" />

    <div class="body">
      <div class="filters">
        <SearchInput delayed @input="setSearch" />
      </div>

      <app-loading :loading="loading" pos="100px">
        <div class="list">
          <div class="scroller">
            <SelectorOverlayContainer
              v-if="items.length"
              :value="uniqueTest"
              :react-on="items"
              ref="overlay"
            >
              <SelectorOverlayItem
                v-for="item in items
                  .map((i) => i)
                  .sort((a, b) =>
                    a.name > b.name ? (a.name < b.name ? -1 : 1) : 0
                  )"
                :key="`${filters.type.replace('-anal', '')}-${item.id}`"
              >
                <ListItem :data="item" />
              </SelectorOverlayItem>
            </SelectorOverlayContainer>
          </div>
        </div>
      </app-loading>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import ListItem from "./ListItem";
import MetaHead from "./MetaHead";
import { mapGetters } from "vuex";
import SearchInput from "@/components/common/SearchInput";
import SidebarSwitcher from "@/components/common/SidebarSwitcher";
import {
  SelectorOverlayContainer,
  SelectorOverlayItem,
} from "@/components/common/selector-overlay";

export default {
  data() {
    return {
      loading: false,
      // menu: [],
    };
  },
  methods: {
    //=================================================================================
    sync() {
      this.loading = true;
      return this.$store
        .dispatch("tests/sidebar/updateData")
        .catch(() => {
          this.$notify({
            group: "notices",
            title: this.$ml.get(`Please buy a plan before selecting tests.`),
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          // this.menu = [];
        });
    },
    //=================================================================================

    selectType(type) {
      this.$store.commit("tests/sidebar/setType", type);
      this.sync();
    },
    setSearch(val) {
      this.$store.commit("tests/sidebar/setSearch", val);
      this.sync();
    },
  },
  created() {
    this.sync();
  },
  computed: {
    ...mapGetters({
      filters: "tests/sidebar/filters",
      items: "tests/sidebar/data",
      haveTests: "tests/sidebar/haveTests",
      menu: "tests/sidebar/menu",
    }),

    // Для нормальной работы SelectorOverlay (при удалении найти SelectorOverlayItem)
    // и посмотреть на его ключ , а возможноо вообше не надо удалять
    uniqueTest() {
      const name = this.$route.name.replace(/\-single|tests\-/g, "");
      return `${name}-${this.$route.params.test}`;
    },
  },
  components: {
    ListItem,
    SelectorOverlayContainer,
    SelectorOverlayItem,
    MetaHead,
    SearchInput,
    SidebarSwitcher,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/vars";

.sidebar {
  min-width: 320px;
  max-width: 320px;
  position: relative;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #e4e5e6;
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .body {
    display: flex;
    flex-direction: column;

    height: calc(100% - 30px);

    .filters {
      padding: 20px 0;
      padding-top: 0;
    }
  }

  .list {
    .scroller {
      overflow-y: auto;
      height: 100%;
      scrollbar-width: thin;
      height: calc(100vh - 280px);
      .selected-overlay {
      }
    }
  }
  @media (max-width: 768px) {
    min-width: 100%;
  }
}
</style>
